import { IS_SELFHOST_DEPLOYMENT } from '@utilities/deployment'
import { useMemo } from 'react'
import { getSubdomain, parse } from 'tldts'
import URL from 'url-parse'
import getEnv, { getCurrentLocationTenantID } from 'utilities/getEnv'
export interface IUrlProperties {
    hostname: string | null
    isIp: boolean | null
    subdomain: string | null
    domain: string | null
    publicSuffix: string | null
    domainWithoutSuffix: string | null
    isIcann: boolean | null
    isPrivate: boolean | null
}

export const parseSubdomainWithUrl = (url: string) => {
    let subdomain = getSubdomain(url)

    if (subdomain === 'www') {
        subdomain = ''
    } else if (subdomain?.startsWith('www.')) {
        subdomain = subdomain.replace('www.', '')
    }
    return subdomain ?? ''
}
const SUB_DOMAIN = getEnv('REACT_APP_SUB_DOMAIN')
function useSubdomain() {
    const subdomain = useMemo(
        () => parseSubdomainWithUrl(window.location.href) || SUB_DOMAIN,
        [],
    )

    const fullUrl = useMemo(() => {
        const properties = new URL(window.location.href)
        return `${properties.origin}`
    }, [])

    const noSubdomainMode = useMemo(() => {
        const isIp = parse(window.location.href).isIp
        return fullUrl.includes('localhost') || !!isIp
    }, [fullUrl])

    const hasTenantID = useMemo(() => {
        return Boolean(getCurrentLocationTenantID())
    }, [])

    return {
        hasTenantID,
        fullUrl,
        subdomain,
        selfHostMode: IS_SELFHOST_DEPLOYMENT || noSubdomainMode,
    }
}

export default useSubdomain
